(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souleve-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const maskPhone = (value) => {
      const digits = value.replace(/\D/g, '').slice(0, 11);
      if (digits.length <= 10) {
        return digits
          .replace(/^(\d{2})(\d)/, '($1) $2')
          .replace(/(\d{4})(\d)/, '$1-$2');
      }
      return digits
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2');
    };

    document.querySelectorAll('[data-souleve-phone-mask]').forEach((input) => {
      const apply = () => {
        input.value = maskPhone(input.value);
      };
      input.addEventListener('input', apply);
      if (input.value) apply();
    });

    document.querySelectorAll('[data-souleve-contact-topic]').forEach((select) => {
      const orderField = select.closest('form')?.querySelector('[data-souleve-order-field]');
      if (!orderField) return;
      const toggle = () => {
        const needsOrder = ['Pedido', 'Envio e entrega', 'Troca e devolução'].includes(select.value);
        orderField.hidden = !needsOrder;
      };
      select.addEventListener('change', toggle);
      toggle();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["souleve-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-souleve-faq]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const search = root.querySelector('[data-souleve-faq-search]');
    const buttons = [...root.querySelectorAll('[data-souleve-faq-category]')];
    const items = [...root.querySelectorAll('[data-souleve-faq-item]')];
    const empty = root.querySelector('[data-souleve-faq-empty]');
    let category = 'all';
    const filter = () => {
      const term = search.value.trim().toLocaleLowerCase('pt-BR');
      let visible = 0;
      items.forEach((item) => {
        const matchesCategory = category === 'all' || item.dataset.category === category;
        const matchesSearch = !term || item.textContent.toLocaleLowerCase('pt-BR').includes(term);
        const show = matchesCategory && matchesSearch;
        item.hidden = !show;
        if (show) visible += 1;
      });
      empty.hidden = visible !== 0;
    };
    const selectCategory = (slug, updateHash = false) => {
      const button = buttons.find((item) => item.id === slug || item.dataset.souleveFaqCategory === slug) || buttons[0];
      category = button.dataset.souleveFaqCategory;
      buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
      filter();
      if (updateHash && button.id && button.id !== 'todas') history.replaceState(null, '', `#${button.id}`);
      return button;
    };
    search.addEventListener('input', filter);
    buttons.forEach((button) => button.addEventListener('click', () => selectCategory(button.id, true)));
    const openFromHash = () => {
      const slug = window.location.hash.replace('#', '');
      if (!slug) return;
      const button = selectCategory(slug);
      button.scrollIntoView({ block: 'nearest' });
      items.filter((item) => !item.hidden && item.dataset.category === button.dataset.souleveFaqCategory).forEach((item) => { item.open = true; });
    };
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  })();

  } catch(e) { console.error(e); }
})();
})();
